export const simulatedHoverMixin = {
    data() {
        return {
            observer: null
        }
    },

    methods: {
        addHoverListeners() {
            document.querySelectorAll('.simulated-hover').forEach(element => {
                element.addEventListener('touchstart', this.handleTouchStart)
                element.addEventListener('touchend', this.handleTouchEnd)
            })
        },

        handleTouchStart(event) {
            event.target.classList.add('onHover')
        },

        handleTouchEnd(event) {
            setTimeout(() => {
                event.target.classList.remove('onHover')
            }, 200)
        },

        removeHoverListeners() {
            document.querySelectorAll('.simulated-hover').forEach(element => {
                element.removeEventListener('touchstart', this.handleTouchStart)
                element.removeEventListener('touchend', this.handleTouchEnd)
            })
        },

        setupObserver() {
            this.observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.addedNodes.length) {
                        this.addHoverListeners()
                    }
                })
            })

            this.observer.observe(document.body, {
                childList: true,
                subtree: true
            })
        }
    },

    mounted() {
        this.addHoverListeners()
        this.setupObserver()
    },

    beforeDestroy() {
        this.removeHoverListeners()
        if (this.observer) {
            this.observer.disconnect()
        }
    }
}
